import apiBanks from "@/services/api.banks";

const state = {
    allBanks: [],
    isLoadingAllBanks: false
}

export const mutationTypes = {
    allBanksStart: '[banks] All Banks start',
    allBanksSuccess: '[banks] All Banks success',
    allBanksFailure: '[banks] All Banks failure',

    createdBankStart: '[banks] Created Bank start',
    createdBankSuccess: '[banks] Created Bank success',
    createdBankFailure: '[banks] Created Bank failure',

    updatedBankStart: '[banks] Created Bank start',
    updatedBankSuccess: '[banks] Created Bank success',
    updatedBankFailure: '[banks] Created Bank failure',
}

export const actionTypes = {
    findBanks: '[banks] Get all banks',
    createdBank: '[banks] Created bank',
    updatedBank: '[banks] Updated bank'
}

export const getterTypes = {
    allBanks: '[banks] All banks',
    isLoadingAllBanks: '[banks] Is loading all banks'
}

const getters = {
    [getterTypes.allBanks]: (state) => {
        return state.allBanks
    },
    [getterTypes.isLoadingAllBanks]: (state) => {
        return state.isLoadingAllBanks
    },
}

const mutations = {
    [mutationTypes.allBanksStart](state) {
        state.isLoadingAllBanks = true
    },
    [mutationTypes.allBanksSuccess](state, payload) {
        state.isLoadingAllBanks = false
        state.allBanks = payload
    },
    [mutationTypes.allBanksFailure](state) {
        state.isLoadingAllBanks = false
    },
    [mutationTypes.createdBankStart](state) {
        state.isLoadingAllBanks = true
    },
    [mutationTypes.createdBankSuccess](state, payload) {
        state.isLoadingAllBanks = false
        state.allBanks = payload
    },
    [mutationTypes.createdBankFailure](state) {
        state.isLoadingAllBanks = false
    },
    [mutationTypes.updatedBankStart](state) {
        state.isLoadingAllBanks = true
    },
    [mutationTypes.updatedBankSuccess](state, payload) {
        state.isLoadingAllBanks = false
        state.allBanks = payload
    },
    [mutationTypes.updatedBankFailure](state) {
        state.isLoadingAllBanks = false
    },
}

const actions = {
    [actionTypes.findBanks](context) {
        return new Promise((resolve) => {
            context.commit(mutationTypes.allBanksStart)
            apiBanks
                .getAllBanks()
                .then((response) => {
                    context.commit(mutationTypes.allBanksSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.allBanksFailure, result.response.data)
                })
        })
    },
    [actionTypes.createdBank](context, payload) {
        return new Promise((resolve) => {
            context.commit(mutationTypes.createdBankStart)
            apiBanks
                .createdBank(payload)
                .then((response) => {
                    context.commit(mutationTypes.createdBankSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.createdBankFailure, result.response.data)
                })
        })
    },
    [actionTypes.updatedBank](context, payload) {
        return new Promise((resolve) => {
            context.commit(mutationTypes.updatedBankStart)
            apiBanks
                .updateBank(payload)
                .then((response) => {
                    context.commit(mutationTypes.updatedBankSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.updatedBankFailure, result.response.data)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations,
    getters,
}